import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type GiftVoucherDataFragment } from '../../../../../api/fragments/GiftVoucherData';
import useCompanyFormats from '../../../../../utilities/useCompanyFormats';

const Container = styled.div`
    margin-top: 24px;
`;
const RentalInfo = styled.div`
    padding: 7px 0;

    border-bottom: 1px solid #cecece;
`;

const Label = styled.div`
    font-size: 16px;
    display: contents;
`;

const Value = styled(Label)`
    font-weight: bold;
`;

type VehicleGiftDescriptionProps = {
    voucher: GiftVoucherDataFragment;
};
const VehicleGiftDescription = ({ voucher }: VehicleGiftDescriptionProps) => {
    const { t } = useTranslation(['giftVoucherVehicleDetails', 'common']);
    const { formatAmountWithCurrency } = useCompanyFormats();

    return (
        <Container>
            <RentalInfo>
                <Row>
                    <Col span={12}>
                        <Label>{t('giftVoucherVehicleDetails:rentalRate.title')}</Label>
                    </Col>
                    <Col span={12}>
                        <Value>
                            {t('giftVoucherVehicleDetails:rentalRate.value', {
                                value: formatAmountWithCurrency(voucher.value),
                            })}
                        </Value>
                    </Col>
                </Row>
            </RentalInfo>

            <RentalInfo>
                <Row>
                    <Col span={12}>
                        <Label>{t('giftVoucherVehicleDetails:rentalDuration.title')}</Label>
                    </Col>
                    <Col span={12}>
                        <Value>
                            {t('giftVoucherVehicleDetails:rentalDuration.value', {
                                day: voucher.numberOfBookingReferenceDays,
                            })}
                        </Value>
                    </Col>
                </Row>
            </RentalInfo>

            <RentalInfo>
                <Row>
                    <Col span={12}>
                        <Label>{t('giftVoucherVehicleDetails:giftAmount.title')}</Label>
                    </Col>
                    <Col span={12}>
                        <Value>
                            {t('giftVoucherVehicleDetails:giftAmount.value', {
                                value: formatAmountWithCurrency(voucher.value * voucher.numberOfBookingReferenceDays),
                            })}
                        </Value>
                    </Col>
                </Row>
            </RentalInfo>
        </Container>
    );
};

export default VehicleGiftDescription;
